import React from 'react';
import { FaHiking, FaWater } from 'react-icons/fa';
import './trails_styles.css'; // Importa os estilos específicos

// Import images
import encontro1 from '../images/encontro1.jpeg';
import encontro3 from '../images/encontro3.jpeg';
import amores1 from '../images/amores1.jpeg';
import amores2 from '../images/amores2.jpeg';

const Trails = () => {
    const encontroImages = [encontro1, encontro3];
    const amoresImages = [amores1, amores2];

    const scrollToBooking = () => {
        const bookingSection = document.querySelector('.booking-widget');
        if (bookingSection) {
            bookingSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section className="trails-section" id="trails">
            <div className="trails-header">
                <h2>Trilhas e Cachoeiras</h2>
                <p className="section-subtitle">Aventure-se no Quintal de Casa</p>
                <p className="trails-intro">
                    Localizado em São Bento do Sapucaí, nosso refúgio é o ponto de partida para experiências inesquecíveis. Diretamente dos nossos chalés, você tem acesso exclusivo a trilhas que cortam a Mata Atlântica, repletas de riachos cristalinos e piscinas naturais.
                </p>
            </div>

            <div className="trails-container">
                {/* Block 1: Cachoeira do Encontro */}
                <div className="trail-block glass-panel">
                    <div className="trail-content">
                        <div className="trail-header-group">
                            <div className="trail-icon"><FaWater /></div>
                            <div className="trail-title-group">
                                <h3>Cachoeira do Encontro</h3>
                                <span className="trail-tag">A Primeira Parada</span>
                            </div>
                        </div>
                        <p>
                            Uma caminhada deliciosa leva você até a Cachoeira do Encontro. É o lugar perfeito para uma dose de aventura e conexão imediata com a natureza. Prepare-se para se refrescar!
                        </p>
                    </div>
                    <div className="trail-gallery">
                        {encontroImages.map((img, index) => (
                            <div key={index} className="gallery-item">
                                <img src={img} alt={`Cachoeira do Encontro ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Block 2: Cachoeira dos Amores */}
                <div className="trail-block glass-panel">
                    <div className="trail-content">
                        <div className="trail-header-group">
                            <div className="trail-icon"><FaHiking /></div>
                            <div className="trail-title-group">
                                <h3>Cachoeira dos Amores</h3>
                                <span className="trail-tag">Piscinas Naturais</span>
                            </div>
                        </div>
                        <p>
                            Seguindo a trilha adiante, o cenário fica ainda mais encantador. Você passará por diversos riachos e piscinas naturais até chegar à deslumbrante Cachoeira dos Amores. O cenário ideal para relaxar e curtir a dois.
                        </p>
                    </div>
                    <div className="trail-gallery">
                        {amoresImages.map((img, index) => (
                            <div key={index} className="gallery-item">
                                <img src={img} alt={`Cachoeira dos Amores ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="trails-cta-container">
                <button className="section-cta" onClick={scrollToBooking}>
                    Reservar 
                </button>
            </div>
        </section>
    );
};

export default Trails;
